import { styled, Typography } from '@mui/material';

export const TypeText = styled(Typography)`
  text-transform: capitalize;
`;
